module.exports = __webpack_public_path__ + "static/media/liquidfill.333dae47.svg";